import { Inject, Injectable, LOCALE_ID, NgModule, Optional } from '@angular/core';
import { NB_DATE_SERVICE_OPTIONS, NbDateService, NbNativeDateService } from '@nebular/theme';
import parse from 'date-fns/parse';
import formatDate from 'date-fns/format';
import getWeek from 'date-fns/getWeek';

/*
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import * as ɵngcc0 from '@angular/core';
class NbDateFnsDateService extends NbNativeDateService {
    constructor(locale, options) {
        super(locale);
        this.options = options || {};
    }
    format(date, format) {
        if (date) {
            return formatDate(date, format || this.options.format, this.options.formatOptions);
        }
        return '';
    }
    parse(date, format) {
        return parse(date, format || this.options.format, new Date(), this.options.parseOptions);
    }
    getId() {
        return 'date-fns';
    }
    getWeekNumber(date) {
        return getWeek(date, this.options.getWeekOptions);
    }
    getDateFormat() {
        return 'YYYY-MM-dd';
    }
}
NbDateFnsDateService.ɵfac = function NbDateFnsDateService_Factory(t) { return new (t || NbDateFnsDateService)(ɵngcc0.ɵɵinject(LOCALE_ID), ɵngcc0.ɵɵinject(NB_DATE_SERVICE_OPTIONS, 8)); };
NbDateFnsDateService.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: NbDateFnsDateService, factory: NbDateFnsDateService.ɵfac });
NbDateFnsDateService.ctorParameters = () => [
    { type: String, decorators: [{ type: Inject, args: [LOCALE_ID,] }] },
    { type: undefined, decorators: [{ type: Optional }, { type: Inject, args: [NB_DATE_SERVICE_OPTIONS,] }] }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NbDateFnsDateService, [{
        type: Injectable
    }], function () { return [{ type: String, decorators: [{
                type: Inject,
                args: [LOCALE_ID]
            }] }, { type: undefined, decorators: [{
                type: Optional
            }, {
                type: Inject,
                args: [NB_DATE_SERVICE_OPTIONS]
            }] }]; }, null); })();

/*
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
const dateFnsServiceProvider = { provide: NbDateService, useClass: NbDateFnsDateService };
class NbDateFnsDateModule {
    static forRoot(options) {
        return {
            ngModule: NbDateFnsDateModule,
            providers: [
                dateFnsServiceProvider,
                { provide: NB_DATE_SERVICE_OPTIONS, useValue: options },
            ],
        };
    }
    static forChild(options) {
        return {
            ngModule: NbDateFnsDateModule,
            providers: [
                dateFnsServiceProvider,
                { provide: NB_DATE_SERVICE_OPTIONS, useValue: options },
            ],
        };
    }
}
NbDateFnsDateModule.ɵfac = function NbDateFnsDateModule_Factory(t) { return new (t || NbDateFnsDateModule)(); };
NbDateFnsDateModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: NbDateFnsDateModule });
NbDateFnsDateModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ providers: [dateFnsServiceProvider] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NbDateFnsDateModule, [{
        type: NgModule,
        args: [{
                providers: [dateFnsServiceProvider]
            }]
    }], null, null); })();

/*
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */

/**
 * Generated bundle index. Do not edit.
 */

export { NbDateFnsDateService, NbDateFnsDateModule };

//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VzIjpbImluZGV4LmpzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7O0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBOzs0SEFHRTtBQUNGO0FBQ0E7QUFDQTtBQUNBOzs7Ozs7Ozs7OztrQ0FBRTtBQUNGO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTs7Ozs7Ozs7OzBCQUtFO0FBQ0Y7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHsgSW5qZWN0LCBJbmplY3RhYmxlLCBMT0NBTEVfSUQsIE5nTW9kdWxlLCBPcHRpb25hbCB9IGZyb20gJ0Bhbmd1bGFyL2NvcmUnO1xuaW1wb3J0IHsgTkJfREFURV9TRVJWSUNFX09QVElPTlMsIE5iRGF0ZVNlcnZpY2UsIE5iTmF0aXZlRGF0ZVNlcnZpY2UgfSBmcm9tICdAbmVidWxhci90aGVtZSc7XG5pbXBvcnQgcGFyc2UgZnJvbSAnZGF0ZS1mbnMvcGFyc2UnO1xuaW1wb3J0IGZvcm1hdERhdGUgZnJvbSAnZGF0ZS1mbnMvZm9ybWF0JztcbmltcG9ydCBnZXRXZWVrIGZyb20gJ2RhdGUtZm5zL2dldFdlZWsnO1xuXG4vKlxuICogQGxpY2Vuc2VcbiAqIENvcHlyaWdodCBBa3Zlby4gQWxsIFJpZ2h0cyBSZXNlcnZlZC5cbiAqIExpY2Vuc2VkIHVuZGVyIHRoZSBNSVQgTGljZW5zZS4gU2VlIExpY2Vuc2UudHh0IGluIHRoZSBwcm9qZWN0IHJvb3QgZm9yIGxpY2Vuc2UgaW5mb3JtYXRpb24uXG4gKi9cbmNsYXNzIE5iRGF0ZUZuc0RhdGVTZXJ2aWNlIGV4dGVuZHMgTmJOYXRpdmVEYXRlU2VydmljZSB7XG4gICAgY29uc3RydWN0b3IobG9jYWxlLCBvcHRpb25zKSB7XG4gICAgICAgIHN1cGVyKGxvY2FsZSk7XG4gICAgICAgIHRoaXMub3B0aW9ucyA9IG9wdGlvbnMgfHwge307XG4gICAgfVxuICAgIGZvcm1hdChkYXRlLCBmb3JtYXQpIHtcbiAgICAgICAgaWYgKGRhdGUpIHtcbiAgICAgICAgICAgIHJldHVybiBmb3JtYXREYXRlKGRhdGUsIGZvcm1hdCB8fCB0aGlzLm9wdGlvbnMuZm9ybWF0LCB0aGlzLm9wdGlvbnMuZm9ybWF0T3B0aW9ucyk7XG4gICAgICAgIH1cbiAgICAgICAgcmV0dXJuICcnO1xuICAgIH1cbiAgICBwYXJzZShkYXRlLCBmb3JtYXQpIHtcbiAgICAgICAgcmV0dXJuIHBhcnNlKGRhdGUsIGZvcm1hdCB8fCB0aGlzLm9wdGlvbnMuZm9ybWF0LCBuZXcgRGF0ZSgpLCB0aGlzLm9wdGlvbnMucGFyc2VPcHRpb25zKTtcbiAgICB9XG4gICAgZ2V0SWQoKSB7XG4gICAgICAgIHJldHVybiAnZGF0ZS1mbnMnO1xuICAgIH1cbiAgICBnZXRXZWVrTnVtYmVyKGRhdGUpIHtcbiAgICAgICAgcmV0dXJuIGdldFdlZWsoZGF0ZSwgdGhpcy5vcHRpb25zLmdldFdlZWtPcHRpb25zKTtcbiAgICB9XG4gICAgZ2V0RGF0ZUZvcm1hdCgpIHtcbiAgICAgICAgcmV0dXJuICdZWVlZLU1NLWRkJztcbiAgICB9XG59XG5OYkRhdGVGbnNEYXRlU2VydmljZS5kZWNvcmF0b3JzID0gW1xuICAgIHsgdHlwZTogSW5qZWN0YWJsZSB9XG5dO1xuTmJEYXRlRm5zRGF0ZVNlcnZpY2UuY3RvclBhcmFtZXRlcnMgPSAoKSA9PiBbXG4gICAgeyB0eXBlOiBTdHJpbmcsIGRlY29yYXRvcnM6IFt7IHR5cGU6IEluamVjdCwgYXJnczogW0xPQ0FMRV9JRCxdIH1dIH0sXG4gICAgeyB0eXBlOiB1bmRlZmluZWQsIGRlY29yYXRvcnM6IFt7IHR5cGU6IE9wdGlvbmFsIH0sIHsgdHlwZTogSW5qZWN0LCBhcmdzOiBbTkJfREFURV9TRVJWSUNFX09QVElPTlMsXSB9XSB9XG5dO1xuXG4vKlxuICogQGxpY2Vuc2VcbiAqIENvcHlyaWdodCBBa3Zlby4gQWxsIFJpZ2h0cyBSZXNlcnZlZC5cbiAqIExpY2Vuc2VkIHVuZGVyIHRoZSBNSVQgTGljZW5zZS4gU2VlIExpY2Vuc2UudHh0IGluIHRoZSBwcm9qZWN0IHJvb3QgZm9yIGxpY2Vuc2UgaW5mb3JtYXRpb24uXG4gKi9cbmNvbnN0IGRhdGVGbnNTZXJ2aWNlUHJvdmlkZXIgPSB7IHByb3ZpZGU6IE5iRGF0ZVNlcnZpY2UsIHVzZUNsYXNzOiBOYkRhdGVGbnNEYXRlU2VydmljZSB9O1xuY2xhc3MgTmJEYXRlRm5zRGF0ZU1vZHVsZSB7XG4gICAgc3RhdGljIGZvclJvb3Qob3B0aW9ucykge1xuICAgICAgICByZXR1cm4ge1xuICAgICAgICAgICAgbmdNb2R1bGU6IE5iRGF0ZUZuc0RhdGVNb2R1bGUsXG4gICAgICAgICAgICBwcm92aWRlcnM6IFtcbiAgICAgICAgICAgICAgICBkYXRlRm5zU2VydmljZVByb3ZpZGVyLFxuICAgICAgICAgICAgICAgIHsgcHJvdmlkZTogTkJfREFURV9TRVJWSUNFX09QVElPTlMsIHVzZVZhbHVlOiBvcHRpb25zIH0sXG4gICAgICAgICAgICBdLFxuICAgICAgICB9O1xuICAgIH1cbiAgICBzdGF0aWMgZm9yQ2hpbGQob3B0aW9ucykge1xuICAgICAgICByZXR1cm4ge1xuICAgICAgICAgICAgbmdNb2R1bGU6IE5iRGF0ZUZuc0RhdGVNb2R1bGUsXG4gICAgICAgICAgICBwcm92aWRlcnM6IFtcbiAgICAgICAgICAgICAgICBkYXRlRm5zU2VydmljZVByb3ZpZGVyLFxuICAgICAgICAgICAgICAgIHsgcHJvdmlkZTogTkJfREFURV9TRVJWSUNFX09QVElPTlMsIHVzZVZhbHVlOiBvcHRpb25zIH0sXG4gICAgICAgICAgICBdLFxuICAgICAgICB9O1xuICAgIH1cbn1cbk5iRGF0ZUZuc0RhdGVNb2R1bGUuZGVjb3JhdG9ycyA9IFtcbiAgICB7IHR5cGU6IE5nTW9kdWxlLCBhcmdzOiBbe1xuICAgICAgICAgICAgICAgIHByb3ZpZGVyczogW2RhdGVGbnNTZXJ2aWNlUHJvdmlkZXJdLFxuICAgICAgICAgICAgfSxdIH1cbl07XG5cbi8qXG4gKiBAbGljZW5zZVxuICogQ29weXJpZ2h0IEFrdmVvLiBBbGwgUmlnaHRzIFJlc2VydmVkLlxuICogTGljZW5zZWQgdW5kZXIgdGhlIE1JVCBMaWNlbnNlLiBTZWUgTGljZW5zZS50eHQgaW4gdGhlIHByb2plY3Qgcm9vdCBmb3IgbGljZW5zZSBpbmZvcm1hdGlvbi5cbiAqL1xuXG4vKipcbiAqIEdlbmVyYXRlZCBidW5kbGUgaW5kZXguIERvIG5vdCBlZGl0LlxuICovXG5cbmV4cG9ydCB7IE5iRGF0ZUZuc0RhdGVTZXJ2aWNlLCBOYkRhdGVGbnNEYXRlTW9kdWxlIH07XG4iXX0=